// ----------------------------------------------------------------------

const account = {
  displayName: "Francisco Guerrero",
  email: "javier@aurorati.mx",
  photoURL: "/static/mock-images/avatars/avatar_default.jpg",
};

export default account;
